import { render, staticRenderFns } from "./RestaurantsWithoutHubCoverage.vue?vue&type=template&id=6f826b00"
import script from "./RestaurantsWithoutHubCoverage.vue?vue&type=script&lang=js"
export * from "./RestaurantsWithoutHubCoverage.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsWithoutHubCoverage.vue?vue&type=style&index=0&id=6f826b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports